// 文章
import Axios from '@/assets/js/ajax'
import {
  FileUpload
} from '@/assets/js/common'
import {
  getPostListUrl,
  getPostUrl,
  commentUrl,
  queryUploadUrl,
  getAvatarUrl,
  postArticleUrl,
  getArticlePermissionUrl,
  getArticleTagsUrl,
  getCategory2Url,
  addTagsUrl,
  likeUrl,
  attachMentUrl,
  getCourseBannerUrl,
  deletePostUrl,
  likeCommentUrl,
  submitPostUrl,
  reasonPostUrl,
  getSmallAvatarUrl
} from '@/assets/js/const'
const state = {
  postList: {}, // 文章列表
  courseList: {}, // 课程列表
  post: {}, // 文章详情
  searchList: {}, // 搜索文章列表
  articlePermission: [], // 文章权限
  articleTags: [], // 文章 or 课程标签
  category2: [], // 文章 or 课程 类型，读研报 ....
  attachMent: [], // 附件
  courseBanner: [],
  hotPostList: [],
}

const getters = {
  postList: state => state.postList,
  post: state => state.post,
  searchList: state => state.searchList,
  articlePermission: state => state.articlePermission,
  articleTags: state => state.articleTags,
  category2: state => state.category2,
  courseList: state => state.courseList,
  attachMent: state => state.attachMent,
  courseBanner: state => state.courseBanner,
  hotPostList: state => state.hotPostList
}

const mutations = {
  setPostList(state, payload) {
    if (!payload.loadMore) {
      state.postList = payload.data
    } else {
      let posts = []
      Object.assign(posts, state.postList.posts)
      state.postList = payload.data
      state.postList.posts = posts.concat(payload.data.posts)
    }
  },
  setCourseList(state, payload) {
    if (!payload.loadMore) {
      state.courseList = payload.data
    } else {
      let posts = []
      Object.assign(posts, state.courseList.posts)
      state.courseList = payload.data
      state.courseList.posts = posts.concat(payload.data.posts)
    }
  },
  setPost(state, payload) {
    state.post = payload
  },
  setSearchList(state, payload) {
    state.searchList = payload
  },
  setArticlePermission(state, payload) {
    state.articlePermission = payload
  },
  setArticleTags(state, payload) {
    state.articleTags = payload
  },
  setCategory2(state, payload) {
    state.category2 = payload
  },
  setAttachMent(state, payload) {
    state.attachMent.push(payload.url)
  },
  setCourseBanner(state, payload) {
    state.courseBanner = payload
  },
  setHotPostList(state, payload) {
    state.hotPostList = payload
  }
}

const actions = {
  async getPostList({
    commit
  }, {
    ca = '',
    p = 1,
    sort = 'updated_at',
    loadMore = false
  }) {
    let {
      data
    } = await Axios.get(getPostListUrl + '?articleType=0&p=' + p + '&sort=' + sort + '&ca=' + ca)
    commit('setPostList', {
      data: data.data,
      loadMore: loadMore
    })
  },
  async getHotPostList({
    commit
  }) {
    let {
      data
    } = await Axios.get(`/hotPost`)
    commit('setHotPostList', data.data)
  },
  async getCourseList({
    commit
  }, {
    p = 1,
    sort = 'updated_at',
    loadMore = false,
    ca = ''
  }) {
    let {
      data
    } = await Axios.get(getPostListUrl + '?articleType=1&p=' + p + '&sort=' + sort + '&ca=' + ca)
    commit('setCourseList', {
      data: data.data,
      loadMore: loadMore
    })
  },
  async getPost({
    commit,
    dispatch
  }, id) {
    let {
      data
    } = await Axios.get(getPostUrl + '/' + id)
    commit('setPost', data.data)
    dispatch('getArticleAttachment', data.data.post.sourceFile)
    return data.data
  },
  async getOnlyCourse({
    commit
  }, id) {
    let {
      data
    } = await Axios.get(getPostUrl + '/' + id)
    commit('setPost', data.data)
    return data.data
  },
  async getSearchList({
    commit
  }, search) {
    let {
      data
    } = await Axios.get(getPostListUrl + '?search=' + search)
    commit('setSearchList', data.data)
  },
  async commentPost({
    dispatch
  }, payload) {
    await Axios.post(commentUrl + '/' + payload._id, {
      toUserId: payload.toUserId || '',
      commentListIndex: payload.commentListIndex || 0,
      content: payload.content
    })
    dispatch('getPost', payload._id)
  },
  /**
   * 发表文章或课程
   * @param {*} param0
   * @param {*} payload
   */
  async savePost({
    dispatch
  }, payload) {
    let {
      data
    } = await Axios.post(postArticleUrl, payload)
    return data.data
  },
  async deletePost({
    dispatch
  }, payload) { // 删除
    await Axios.post(deletePostUrl + '/' + payload)
  },
  async submitPost({
    dispatch
  }, payload) { // 提交审核
    await Axios.get(submitPostUrl + payload)
  },
  async reasonPastPost({
    dispatch
  }, payload) { // 未通过及通过审核
    await Axios.post(reasonPostUrl, {
      postId: payload.postId,
      auditState: payload.auditState
    })
  },
  async likePost({
    dispatch
  }, payload) { // 点赞文章
    await Axios.post(likeUrl, {
      type: 2,
      uid: payload.uid,
      id: payload.id
    })
    dispatch('getPost', payload.id)
  },
  async collectPost({}, payload) { // 收藏文章
    await Axios.get(likeUrl, {
      type: 1,
      uid: payload.uid,
      id: payload.id
    })
  },
  async getArticlePermission({
    commit
  }) {
    let {
      data
    } = await Axios.post(getArticlePermissionUrl)
    commit('setArticlePermission', data.data)
  },
  async getArticleTags({
    commit
  }) {
    let {
      data
    } = await Axios.get(getArticleTagsUrl)
    commit('setArticleTags', data.data)
  },
  async getCategory2({
    commit
  }) {
    let {
      data
    } = await Axios.get(getCategory2Url)
    commit('setCategory2', data.data.categorys2)
  },
  async addTags({
    dispatch
  }, payload) {
    let {
      data
    } = await Axios.post(addTagsUrl, {
      name: payload
    })
    await dispatch('getArticleTags')
    return data.data._id
  },
  async getArticleAttachment({
    commit
  }, payload) {
    console.log('getArticleAttachment',payload);
    for (let i in payload) {
      commit('setAttachMent', {
        url: payload[i].url
      })
    }
  },
  async getCourseBanner({
    commit
  }, payload) {
    let {
      data
    } = await Axios.get(getCourseBannerUrl)
    commit('setCourseBanner', data.data)
  },
  async likeComment({
    dispatch
  }, payload) {
    await Axios.get(likeCommentUrl + '/' + payload.id, {
      params: {
        commentIndex: payload.commentIndex
      }
    })
    dispatch('getPost', payload.id)
  },
  /**
   * 上传文件第一步查询上传文件地址
   * @param {*} param0
   * @param {*} param1
   */
  async queryUpload({}, {
    fileName,
    fileSize,
    fileMd5,
    type
  }) {
    let {
      data
    } = await Axios.get(queryUploadUrl, {
      params: {
        name: fileName,
        size: fileSize,
        md5: fileMd5,
        type: type
      }
    })
    return data
  },
  /**
   * 上传文件第一步查询上传文件地址
   * @param {*} param0
   * @param {*} param1
   */
   async queryUploadFile({}, {
    fileName,
    fileSize,
    fileMd5,
    type
  }) {
    let {
      data
    } = await Axios.get(queryUploadFileUrl, {
      params: {
        name: fileName,
        size: fileSize,
        md5: fileMd5,
        type: type
      }
    })
    return data
  },



  /**
   * 上传文件第二步
   * 
   * @param {上传文件第一步返回的地址} url
   * @param {断点续传（云盘功能，暂时未发现可用）} number
   * @param {上传的文件} file
   * @param {onProgress} elementui 进度条
   */
  async uploadFile({}, {
    file,
    onProgress
  }) {
    let result = {},
      fd = new FormData();
    fd.append('file', file)
    result = await Axios({
      method: 'post',
      url: `${queryUploadUrl}?ip=172.20.166.18`,
      data: fd,
      // onUploadProgress: function (progressEvent) {
      //   progressEvent.percent = (progressEvent.loaded / progressEvent.total) * (1 / chunks) * 100 + currentChunk / chunks * 100
      //   onProgress(progressEvent)
      // },
      transformRequest: [function (data) {
        return data
      }],
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: false
    })

    return result
  },
  /**
   * 获取云盘文件路径
   * @param {}
   * @param {文件id} file_id
   */

  async getFileSrc({}, {
    file_id
  }) {
    let {
      data
    } = await Axios.get(getAvatarUrl + '?file_id=' + file_id)
    return data.url
  },
  async getSmallFileSrc({}, payload) {
    let {
      data
    } = await Axios.get(getSmallAvatarUrl + '&file_id=' + payload)
    return data.url
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}